import { get } from '../../utils/axios'

export const listReportAttendanceAPI = async (body) => {
  return await get('report/attendance', body)
}
